import { useEffect } from 'react';
import './App.scss';
import { BrowserRouter } from "react-router-dom";
import AppRouter from "./router/AppRouter";
import Application from "./index";

import Cookies from 'universal-cookie';
import Authorization from './components/Authorization/Authorization';

import { useFetching } from './hooks/useFetching';
import PostService from './API/PostService';
import { setCurrentUserAction } from './store/currentUserReducer';
import { useDispatch, useSelector } from 'react-redux';

function App() {
	const dispatch = useDispatch();
	const currentUser = useSelector(state => state.currentUser.currentUser)
	const cookies = new Cookies(null, { domain: '.crm.optictoria.ru' });
	const authCookie = cookies.get('CRM-AUTH');

	useEffect(() => {
		fetchUserInfo();
	}, [])

	useEffect(() => {
		if (!currentUser) {
			fetchUserInfo();
		}
	}, [currentUser])

	const [fetchUserInfo] = useFetching(async () => {
		const response = await PostService.getUserInfo()
		if (response.data.success && response.data.result !== false) {
			dispatch(setCurrentUserAction(response.data.result))
		}
	})

	return (
		<BrowserRouter>
			<Application />
			{
				// authCookie && authCookie === 'Y' &&
				currentUser && currentUser?.id &&
				<div className="app page-holder">
					<AppRouter />
				</div>
			}
			{
				// (!authCookie || authCookie !== 'Y') &&
				(!currentUser && !currentUser?.id) &&
				<Authorization />
			}
		</BrowserRouter>
	);
}

export default App
